import CorpAllowancesModal, { AllowanceModalTypes } from './CorpAllowancesModal';
export default CorpAllowancesModal;
export { AllowanceModalTypes };
